import { track } from '@cinch-labs/customer-data-segment'
import { FullWidthCTA, FullWidthCTAProps } from '@cinch-labs/design-system'
import {
  EventActions,
  EventCategories,
  EventNames,
  sendDigitalDataEvent,
} from '@cinch-nx/shared-analytics'
import { datadogRum } from '@datadog/browser-rum'
import { useRouter } from 'next/router'
import styles from './pre-footer-cta-v2-wrapper.module.css'
const aboutDeliverySearchAllCars = () => {
  const evt = {
    event: {
      name: EventNames.click,
      category: EventCategories.button,
      label: 'delivery page search',
      action: EventActions.search,
    },
  }
  sendDigitalDataEvent(evt)
  track('Delivery page search all cars', evt)
}

export const PreFooterCtaV2Wrapper = (props: FullWidthCTAProps) => {
  const router = useRouter()

  const onClickHandler = () => {
    aboutDeliverySearchAllCars()
    datadogRum.addAction('AboutDeliverySearchAllCarsClicked')
    router.push('/used-cars')
  }

  return (
    <div className={styles.wrapper}>
      <FullWidthCTA {...props} onButtonClick={onClickHandler} />
    </div>
  )
}
